import { useIntlContext } from '../context/intl-context';
import { revertPathToDefaultLocale } from '../index';

export const useRevertPathToDefaultLocale = (path) => {
  const intl = useIntlContext();

  return revertPathToDefaultLocale(path, intl);
};
